<div *ngIf="data?.asOfDate;else noData">
    <div class="toggle-container">
        <c11n-segmented-control *ngIf="profileData?.isETF" size="small" color="ink"
            legendText="Market Price/Nav Toggle" (stateChange)="onChange($event)" class="quarterly-toggle-width">
            <c11n-segment id="Market" labelText="Market Price" class="c11n-segmented-control__segment--active">
                <input c11n-segment-input type="radio" id="market-price" name="segment-group-quarterly" [value]="'marketPrice'" data-rpa-tag-id="pf-tr-quaterly-buttonMarket">
            </c11n-segment>
            <c11n-segment id="Nav" labelText="Nav">
                <input c11n-segment-input type="radio" id="nav-price" name="segment-group-quarterly" [value]="'nav'" data-rpa-tag-id="pf-tr-quaterly-buttonNAV">
            </c11n-segment>
        </c11n-segmented-control>
        <p class="disclaimer rps-grey rps-paragraph-two" data-rpa-tag-id="qtrDate">as of {{ data?.asOfDate | ESTPipe |
            DashIfEmpty }}</p>
    </div>
    <div style="position: relative;">
        <div class="table-container">
            <table scrollingTable aria-label="Performance quarterly">
                <thead>
                    <tr>
                        <th scope="col">Year</th>
                        <th scope="col">1st Qtr</th>
                        <th scope="col">2nd Qtr</th>
                        <th scope="col">3rd Qtr</th>
                        <th scope="col">4th Qtr</th>
                        <th scope="col">Year-end</th>
                        <th scope="col">
                            <p class="tool-tip-cell">
                                <label>Benchmark<sup
                                        *ngIf="benchmarkFootNote?.text">{{benchmarkFootNote?.id}}</sup></label>
                                <c11n-tooltip [autoOrientation]="false" colorMode="on-light" direction="left"
                                    labelText="Benchmark" class="inner-align">
                                    <span c11nTooltipContent>{{ data?.benchmarkShortName || '(Benchmark)' }}</span>
                                </c11n-tooltip>
                            </p>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let return of tableData">
                        <th scope="col" data-rpa-tag-id="yearQtr">{{return?.year | DashIfEmpty }}</th>
                        <td scope="col" data-rpa-tag-id="firstQtrPct">{{return?.firstQtrRtn | VMFPercent | DashIfEmpty
                            }}</td>
                        <td scope="col" data-rpa-tag-id="secondQtrPct">{{return?.secondQtrRtn | VMFPercent | DashIfEmpty
                            }}</td>
                        <td scope="col" data-rpa-tag-id="thirdQtrPct">{{return?.thirdQtrRtn | VMFPercent | DashIfEmpty
                            }}</td>
                        <td scope="col" data-rpa-tag-id="fourthQtrPct">{{return?.fourthQtrRtn | VMFPercent | DashIfEmpty
                            }}</td>
                        <td scope="col" data-rpa-tag-id="yearEndPct">{{return?.yearEndRtn | VMFPercent | DashIfEmpty }}
                        </td>
                        <td scope="col" data-rpa-tag-id="yearEndRtnBenchmrk">{{return?.benchmarkYearEndRtn | VMFPercent
                            | DashIfEmpty }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>

<ng-template #noData>
    <p *ngIf="!data?.asOfDate" class='no-data'>This information is temporarily unavailable.</p>
</ng-template>
